if (!customElements.get('attention-bar')) {

  class AttentionBar extends HTMLElement {
    constructor() {
      super();

      this.attentions = this.querySelectorAll('[data-attention]');
      this.date = Date.now();
      this.match = false;

      this.displayAttention();
    }

    displayAttention() {

      this.attentions.forEach((attention) => {

        // Get options
        const options = parseJson(attention.dataset.attention);

        // Get start date
        let startDate = new Date();
        startDate.setDate(startDate.getDate() - 1);
        if (options.start_date != "no-date") {
          const startDateArray = options.start_date.split('-');
          startDate = new Date();
          startDate.setFullYear(startDateArray[2]);
          startDate.setMonth(startDateArray[1] - 1);
          startDate.setDate(startDateArray[0]);
        }

        // Add start time
        const startTimeArray = options.start_time.split(':');
        startDate.setHours(startTimeArray[0]);
        startDate.setMinutes(startTimeArray[1]);
        startDate.setSeconds(0);

        // Get end date
        let endDate = new Date();
        endDate.setDate(endDate.getDate() + 1);
        if (options.start_date != "no-date") {
          const endDateArray = options.end_date.split('-');
          endDate = new Date();
          endDate.setFullYear(endDateArray[2]);
          endDate.setMonth(endDateArray[1] - 1);
          endDate.setDate(endDateArray[0]);
        }

        // Add end time
        const endTimeArray = options.end_time.split(':');
        endDate.setHours(endTimeArray[0]);
        endDate.setMinutes(endTimeArray[1]);
        endDate.setSeconds(0);

        // If date match
        if (!this.match && this.date >= startDate && this.date <= endDate) {

          // if match
          if (options.has_iso_code) {
            this.match = true;
            attention.classList.remove('hide');
            return false;
          }
        }
      });

    }
  }

  window.AttentionBar = AttentionBar;

  customElements.define('attention-bar', AttentionBar);

}
